import { defineMessages } from 'react-intl';

/** The type tags, the names and the one-line summaries of the block rows (design d0). */
export const blockSummaryMessages = defineMessages({
  typeText: { id: 'app.sml.smartlinks.editor.type.text', defaultMessage: 'Text' },
  typeLink: { id: 'app.sml.smartlinks.editor.type.link', defaultMessage: 'Link' },
  typePlayer: { id: 'app.sml.smartlinks.editor.type.player', defaultMessage: 'Player' },
  typeMedia: { id: 'app.sml.smartlinks.editor.type.media', defaultMessage: 'Media' },
  typeSocial: { id: 'app.sml.smartlinks.editor.type.social', defaultMessage: 'Social links' },
  typeProfile: { id: 'app.sml.smartlinks.editor.type.profile', defaultMessage: 'Profile' },
  typeCatalogLinks: { id: 'app.sml.smartlinks.editor.type.catalog_links', defaultMessage: 'Catalog links' },
  typeSubscribe: { id: 'app.sml.smartlinks.editor.type.subscribe', defaultMessage: 'Get every release' },
  typeImage: { id: 'app.sml.smartlinks.editor.type.image', defaultMessage: 'Image' },
  typeUnknown: { id: 'app.sml.smartlinks.editor.type.unknown', defaultMessage: 'Block' },
  styleTitle: { id: 'app.forms.widget.type-option.title', defaultMessage: 'Title' },
  styleNormal: { id: 'app.forms.widget.type-option.normal', defaultMessage: 'Normal' },
  styleSmall: { id: 'app.forms.widget.type-option.Small', defaultMessage: 'Small' },
  emptyText: { id: 'app.sml.smartlinks.editor.summary.empty_text', defaultMessage: 'No text yet' },
  textSummary: { id: 'app.sml.smartlinks.editor.summary.text', defaultMessage: '{style} · "{words}"' },
  linkNoAddress: { id: 'app.sml.smartlinks.editor.summary.link_no_address', defaultMessage: 'No address yet' },
  linkOpensPage: { id: 'app.sml.smartlinks.editor.summary.link_page', defaultMessage: 'Opens one of your pages' },
  listenOn: { id: 'app.sml.smartlinks.editor.name.listen_on', defaultMessage: 'Listen on {service}' },
  watchOn: { id: 'app.sml.smartlinks.editor.name.watch_on', defaultMessage: 'Watch on {service}' },
  playerName: { id: 'app.sml.smartlinks.editor.name.player', defaultMessage: '{service} player' },
  playerSummary: { id: 'app.sml.smartlinks.editor.summary.player', defaultMessage: '{service} · {size}' },
  sizeNormal: { id: 'app.sml.smartlinks.editor.player.size.normal', defaultMessage: 'Normal' },
  sizeCompact: { id: 'app.sml.smartlinks.editor.player.size.compact', defaultMessage: 'Compact' },
  socialSummary: {
    id: 'app.sml.smartlinks.editor.summary.social',
    defaultMessage: '{count, plural, one {# profile} other {# profiles}} · {names}',
  },
  socialEmpty: {
    id: 'app.sml.smartlinks.editor.summary.social_empty',
    defaultMessage: 'No profiles yet · hidden on the page',
  },
  profileSummary: { id: 'app.sml.smartlinks.editor.summary.profile', defaultMessage: 'Photo, name and bio' },
  catalogPresave: {
    id: 'app.sml.smartlinks.editor.summary.catalog_presave',
    defaultMessage: 'Pre-save on {count, plural, one {# service} other {# services}} · until {date}',
  },
  catalogAutoAdded: {
    id: 'app.sml.smartlinks.editor.summary.catalog_auto_added',
    defaultMessage: 'Added by itself · pre-save until {date}',
  },
  catalogLive: {
    id: 'app.sml.smartlinks.editor.summary.catalog_live',
    defaultMessage: '{count, plural, one {# service} other {# services}} · links update by themselves',
  },
  catalogNoLinks: {
    id: 'app.sml.smartlinks.editor.summary.catalog_no_links',
    defaultMessage: 'No links yet · the page says "links soon"',
  },
  catalogUntilRelease: {
    id: 'app.sml.smartlinks.editor.summary.catalog_until_release',
    defaultMessage: 'The links show from {date}',
  },
  catalogNoDate: {
    id: 'app.sml.smartlinks.editor.summary.catalog_no_date',
    defaultMessage: 'The links show when the song is out',
  },
  catalogClosed: {
    id: 'app.sml.smartlinks.editor.summary.catalog_closed',
    defaultMessage: 'Hidden on the page: the pre-save ended',
  },
  imageSummary: {
    id: 'app.sml.smartlinks.editor.summary.image',
    defaultMessage: 'Old picture block · turn into Media',
  },
  imageName: { id: 'app.sml.smartlinks.editor.name.image', defaultMessage: 'Picture' },
  hiddenPrefix: { id: 'app.sml.smartlinks.editor.summary.hidden', defaultMessage: 'Hidden on the page · {summary}' },
  hiddenOnly: { id: 'app.sml.smartlinks.editor.summary.hidden_only', defaultMessage: 'Hidden on the page' },
});
